import React from 'react';
import TransactionSplitEditComponent from "../TransactionSplitEditComponent.jsx";
import MoneyComponent from "../../elements/MoneyComponent.jsx";

export default function TransactionSummarySplit({
	                                                transaction,
	                                                editing,
	                                                showCategory,
	                                                showSplitCategories,
	                                                categoryEditable,
	                                                editSplitAmount,
	                                                editSplitChange,
													...props
                                                }) {


	return (
		<React.Fragment>
			{transaction.isSplit() &&
			<React.Fragment>
				{transaction.splits.map((split, index) => (
					<div key={split.id || `index-${index}`}
					     className={`row ${editing ? '' : ''}`}>
						<TransactionSplitEditComponent
							{...props}
							transaction={transaction}
							transactionSplit={split}
							viewOnly={!editing}
							canRemoveSplit={true}
							editSplitAmount={editSplitAmount}
							editSplitChange={editSplitChange}
							showCategory={showCategory || showSplitCategories}
							categoryEditable={categoryEditable}
						/>
					</div>
				))}
				{editing &&
				<React.Fragment>
					<div className='row remaining section'>
						{transaction.splits.length > 0 &&
						<div className='col offset-s7 s5'>
							<MoneyComponent
								amount={transaction.getUnsplitAmount()}
							/>
							{' '}
							Remaining
						</div>
						}
					</div>
				</React.Fragment>
				}
			</React.Fragment>
			}
		</React.Fragment>
	)
}